import styled, { css } from "styled-components";
import VideoInput from "../videoInput/VideoInput";

export const ConferanceRoomContainer = styled.div`
  flex-direction: column;
  height: 100%;
  max-width: 100vw;
  align-self: center;
  margin: auto;
  background-color: #000000;

  .remote-video-container {
    width: 100vw;
    position: absolute;
    top: 18%;
    left: 0px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media all and (orientation:landscape) {
      height:100%;
      top: 0px;
      bottom:0px;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      text-align:center;
     };
  };
  .team-video-container {
    position: absolute;
    height:88%;
    top: 12px;
    width:100%;
    display:block;
    text-align:center;
    align-self:start;
    @media (orientation:landscape) {
      display:flex;
      flex-direction: row;
      top:0px;
      justify-content: center;
      align-items: center;
      height:100%;
      max-width: 100vw;
      
     };
    };

  };
  .viewStyleSingle
  {
    width: 100%;
    height: 60vh;
    object-fit: cover;
    @media all and (orientation:landscape) {
      width: 50%;
      height: 100vh;
      object-fit: cover;
    };

  };
  .viewStyleTeam
  {
    display:flex;
    height: 37vh;
    width:85%;
    object-fit: cover;
    margin: auto;
    padding: 0px;

    @media (max-height: 700px) {
      height: 35vh;
    };
    @media all and (orientation:landscape) {
      display:flex;
      width: 39vw;
      height: 100vh;
      object-fit: cover;
     
    };
  };
  .isLandscape{
    visibility: hidden;
    @media all and (orientation:landscape) {
      visibility: visible;
    };
  }
`;

interface ButtonContainerProps {
  isDuUser?: boolean;
}
export const ButtonContainer = styled.div<ButtonContainerProps>`
  position: absolute;
  width: 100%;
  bottom: 0;
  justify-content: center;
  display: flex;
  height: 80px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  padding: 8px;
  gap: 32px;
  .normalBtn,
  .cancelBtn,
  .offBtn {
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.12);
    width: 48px;
    height: 48px;
    border-radius: 12px;
  }
  .end-text {
    color: rgba(255, 255, 255, 0.6);
    text-align: center;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    margin-top: 4px;
    padding: 1px;
  }

  ${(props) =>
    props.isDuUser &&
    css`
  @media all and (orientation: landscape) {
      right: 0;
      top: 0;
      width: 10vw;
      height: 100%;
      padding: 1px;
      flex-direction: column;
      
  `}
`;

export const LocalVideo = styled(VideoInput)`
  width: 100%;
  height: 100%;
`;

export const NoVideoViewContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HUViewContainer = styled.div`
  color: white;
  text-wrap: wrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: "Source Sans Pro";
  text-align: center;
  font-feature-settings: "clig" off, "liga" off;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 118%;
  align-items: center;
  position: absolute;
  //top: 20%;
  height: 60vh;
  width: 100%;

  .text {
    transition: opacity 0.5s ease, transform 0.5s ease;
    opacity: 1;
    transform: translateY(0);
  }
  .text.hide {
    opacity: 0;
    transform: translateY(-20px);
  }
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  .background-div {
    width: 80px;
    height: 80px;
    background: #0a5;
    border-radius: 500px;
    padding: 12.5px 12.25px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: width 0.5s ease-in-out, height 0.5s ease-in-out;
    box-sizing: border-box;
  }
  .icon {
    width: 48px;
    height: 47px;
    transition: width 0.5s ease-in-out, height 0.5s ease-in-out;
  }
  .icon.large {
    width: 95px;
    height: 94px;
  }
  .background-div.large-div {
    width: 160px;
    height: 160px;
  }
`;
